<form [formGroup]="kinderenFg">
  <div class="row">
    <div formArrayName="kinderen">
      @if (kinderen.length === 0) {
        <snelstart-ui-alert type="info">
          Er zijn nog geen kinderen ingevuld. Vul eerst bij 'Kindgebonden budget' de kinderen in. <br/>
          Daarna kunnen hier per kind de gegevens voor de kinderopvang worden ingevuld.
        </snelstart-ui-alert>
      } @else if (!hasChildrenYoungerThan13) {
        <snelstart-ui-alert type="info">
          Er zijn geen kinderen jonger dan 13 jaar ingevuld die naar de dag- of buitenschoolse opvang (kunnen)
          gaan.
        </snelstart-ui-alert>
      } @else {
        <div *ngFor="let item of kinderen.controls; let i = index;" [formGroupName]="i">
          <div formArrayName="opvangPerKind">
            <div *ngFor="let item2 of getOpvangPeriodes(i).controls; let j = index" [formGroupName]="j">
              <div class="row mb-0.5">
                <div class="col-auto">
                  <snelstart-ui-text-form-control (change)="saveForm()"
                                                  [label]="j === 0 ? 'Omschrijving' : ''"
                                                  class="custom-input-125"
                                                  formControlName="naamKinderopvanginstelling"
                                                  id="naamKinderopvanginstelling"
                  >
                  </snelstart-ui-text-form-control>
                </div>
                <div class="col-auto">
                  <div formGroupName="periodeOpvang">
                    <snelstart-ui-date-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Opvang van' : ''"
                                                    class="custom-input-100"
                                                    formControlName="begindatum"
                                                    id="begindatum"
                                                    placeholder="dd-mm-{{this.year}}"
                    >
                    </snelstart-ui-date-form-control>
                  </div>
                </div>
                <div class="col-auto">
                  <div formGroupName="periodeOpvang">
                    <snelstart-ui-date-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Opvang t/m' : ''"
                                                    class="custom-input-100"
                                                    formControlName="einddatum"
                                                    id="einddatum"
                                                    placeholder="dd-mm-{{this.year}}"
                    >
                    </snelstart-ui-date-form-control>
                  </div>
                </div>
                <div class="col-auto">
                  <snelstart-ui-bsn-form-control (change)="saveForm()"
                                                 [label]="j === 0 ? 'LRK nummer' : ''"
                                                 class="custom-input-100"
                                                 formControlName="identificatienummerInstelling"
                                                 id="identificatienummerInstelling"
                  >
                  </snelstart-ui-bsn-form-control>
                </div>
                <div class="col-auto">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Uren p/mnd' : ''"
                                                    [showAllDecimals]="false"
                                                    class="custom-input-100"
                                                    formControlName="urenPerMaand"
                                                    id="urenPerMaand"
                  >
                  </snelstart-ui-number-form-control>
                </div>
                <div class="col-auto">
                  <snelstart-ui-number-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Uurprijs' : ''"
                                                    [showAllDecimals]="true"
                                                    align="right"
                                                    class="custom-input-100" formControlName="uurprijs"
                                                    id="uurprijs"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                </div>
                <div class="col-auto">
                  <snelstart-ui-select-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Vorm' : ''"
                                                    [options]="opvangVorm"
                                                    class="custom-input-125"
                                                    formControlName="opvangVorm"
                                                    id="opvangVorm"
                  >
                  </snelstart-ui-select-form-control>
                </div>
                <div class="col-auto">
                  <snelstart-ui-select-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Soort' : ''"
                                                    [options]="opvangSoort"
                                                    class="custom-input-125"
                                                    formControlName="soortOpvang"
                                                    id="soortOpvang"
                  >
                  </snelstart-ui-select-form-control>
                </div>
                <div class="col-auto">
                  <snelstart-ui-button (click)="deleteOpvangperiode(i, j)"
                                       [class]="i === 0 ? 'firstrowbutton' : ''"
                                       icon="trash"
                                       iconType="light"
                                       id="buttonDelete"
                                       size="medium"
                                       type="secondary"
                  >
                  </snelstart-ui-button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="getOpvangPeriodes(i).length === 0 && isJongerDan13Jaar(item.getRawValue().geboortedatum)">
            <snelstart-ui-button (click)="addOpvangPeriodes(i)" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Gegevens opvang voor {{ item.getRawValue().voornaam }} invullen
            </snelstart-ui-button>
          </div>

          <div *ngIf="getOpvangPeriodes(i).length > 0">
            <snelstart-ui-button (click)="addOpvangPeriodes(i)" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Opvanggegevens voor {{ item.getRawValue().voornaam }} toevoegen
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </div>
</form>
